import { tokens } from "@/styles/generated/tokens";
/**
 * Shared types and constants for Audio taxonomy
 * Used by both the filter panel and tag assigners
 */

// Audio role (single-select per asset)
// Note: Using "speech" internally for backward compatibility, displayed as "Dialogue"
export type AudioRole = "sfx" | "speech" | "music";

// Role options with display labels
export const AUDIO_ROLE_OPTIONS: { id: AudioRole; label: string }[] = [
  { id: "sfx", label: "SFX" },
  { id: "speech", label: "Dialogue" },
  { id: "music", label: "Music" },
];

// Audio source (single-select per asset)
export type AudioSource = "uploaded" | "generated";

// Source options with display labels
export const AUDIO_SOURCE_OPTIONS: { id: AudioSource; label: string }[] = [
  { id: "uploaded", label: "Uploaded" },
  { id: "generated", label: "Generated" },
];

// Keep resolved hex colours and their alpha-compatible RGB channels in sync.
function taxonomyColor(hex: string) {
  return {
    hex,
    rgb: [1, 3, 5]
      .map((offset) => parseInt(hex.slice(offset, offset + 2), 16))
      .join(", "),
  };
}

// Shared by upload tagging, audio controls and library filters.
export const TAXONOMY_COLORS = {
  role: taxonomyColor(tokens.COLOR_PRIMITIVE_PINK_500),
  scene: taxonomyColor(tokens.COLOR_PRIMITIVE_INDIGO_500),
  category: taxonomyColor(tokens.COLOR_PRIMITIVE_VIOLET_500),
  source: taxonomyColor(tokens.COLOR_PRIMITIVE_BLUE_500),
} as const;

export const SOURCE_DOT_COLORS = {
  uploaded: tokens.COLOR_PRIMITIVE_NEUTRAL_300,
  generated: tokens.COLOR_PRIMITIVE_BLUE_500,
} as const;

// Mock scenes - in production, these would come from the Shot Builder
export const MOCK_SCENES = [
  { id: "scene-1", name: "Scene 1" },
  { id: "scene-2", name: "Scene 2" },
  { id: "scene-3", name: "Scene 3" },
];

// Asset tags interface
export interface AudioAssetTags {
  role: AudioRole | null;
  sceneIds: string[];
  categories: string[];
  source: AudioSource | null;
}

// Default empty tags
export const EMPTY_TAGS: AudioAssetTags = {
  role: null,
  sceneIds: [],
  categories: [],
  source: null,
};
